import { getAgentBrand } from './getAgentBrand.ts';
import type { AgentIconType } from '@atlassian/do-not-use-agent-brand/agent-icon-type';
import { toUsableIdentityAccountId } from './toUsableIdentityAccountId.ts';

const FALLBACK_KEY_PREFIX = '__fallback__:';
export const FALLBACK_KEY_ROVO: '__fallback__:rovo_chat' = `${FALLBACK_KEY_PREFIX}rovo_chat`;
export const FALLBACK_KEY_UNKNOWN: '__fallback__:unknown' = `${FALLBACK_KEY_PREFIX}unknown`;
const ROVO_FALLBACK_DISPLAY_NAME = 'Rovo';

export type ClickableAgentIdentity = {
	accountId?: string | null;
	agentIcon?: AgentIconType;
	groupKey?: string;
	displayName?: string;
};

export const isClickableAgentIdentity = ({
	accountId,
	agentIcon,
	groupKey,
	displayName,
}: ClickableAgentIdentity): boolean => {
	const isAriAccountId = Boolean(accountId?.startsWith('ari:'));
	if (!isAriAccountId && !toUsableIdentityAccountId(accountId)) {
		return false;
	}
	if (agentIcon) {
		return false;
	}
	if (groupKey && (groupKey === FALLBACK_KEY_UNKNOWN || groupKey === FALLBACK_KEY_ROVO)) {
		return false;
	}
	if (displayName === ROVO_FALLBACK_DISPLAY_NAME) {
		return false;
	}
	const brand = displayName ? getAgentBrand(displayName) : undefined;
	if (brand && brand.agentIcon !== 'rovo') {
		return false;
	}
	return true;
};
